import { useEffect } from 'react';
import { api } from '../lib/api';

const SESSION_KEY = 'geniusmind_session_id';
const HEARTBEAT_INTERVAL_MS = 45 * 1000;

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = crypto.randomUUID();
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

// Keeps a live presence record for this browser tab so the homepage can show
// a real "reading now" count instead of a hardcoded number.
export function usePresenceHeartbeat() {
  useEffect(() => {
    const sessionId = getSessionId();
    const send = () => { api.post('/presence/heartbeat', { sessionId }).catch(() => {}); };

    send();
    const interval = setInterval(send, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);
}
